import React, { useRef } from "react";
import PropTypes from "prop-types";
import { DateRangePicker } from "rsuite";
import { beforeToday } from "rsuite/cjs/DateRangePicker/disabledDateUtils";
import { formatDateRange } from "../../../utils/dateUtils";
import deleteIcon from "../../../assets/img/delete.svg";
import checkboxIcon from "../../../assets/img/checkbox.svg";
import uncheckedCheckboxIcon from "../../../assets/img/empty-checkbox.svg";

/**
 * BlackoutDatesSection - Blackout dates section with multiple date ranges
 */
function BlackoutDatesSection({
  blackoutDates = [],
  onBlackoutDateChange,
  onRemoveBlackoutDate,
  onAddBlackoutDate,
  onToggleAllowStayThrough,
  onRemoveSection = () => {},
}) {
  const boDateCalendarPopupRef = useRef([]);

  return (
    <div className="tc-section condition-form-section">
      {blackoutDates?.map((item, index) => (
        <div key={item.id} className="condition-row blackout-row">
          {index === 0 ? (
            <span className="condition-label">Blackout Dates</span>
          ) : (
            <span className="condition-label condition-label-empty"></span>
          )}
          <div className="condition-input-wrapper">
            <DateRangePicker
              placement={"bottom"}
              value={item.dates}
              onChange={(value) => onBlackoutDateChange(value, item.id)}
              placeholder="Select date range"
              block
              container={() => boDateCalendarPopupRef.current[item.id]}
              renderValue={formatDateRange}
              shouldDisableDate={beforeToday()}
              disableddateStyle={{
                backgroundColor: "#f5f5f5",
                color: "#999",
              }}
            />
            <div
              className="position-relative"
              ref={(ref) => (boDateCalendarPopupRef.current[item.id] = ref)}
            />
            <label
              className={`staythrough-checkbox ${
                item.allowStayThrough ? "checked" : ""
              }`}
            >
              <input
                type="checkbox"
                checked={item.allowStayThrough}
                onChange={() => onToggleAllowStayThrough(item.id)}
                className="sr-only"
              />
              {item.allowStayThrough ? (
                <img src={checkboxIcon} alt="check" className="check-icon" />
              ) : (
                <img
                  src={uncheckedCheckboxIcon}
                  alt="check"
                  className="check-icon"
                />
              )}
              <span>Allow stay through</span>
            </label>
          </div>
          <button
            type="button"
            className="remove-condition-btn"
            onClick={() => onRemoveBlackoutDate(item.id)}
          >
            <img src={deleteIcon} alt="Delete" className="delete-icon" />
          </button>
        </div>
      ))}
      {blackoutDates.length > 0 && (
        <div className="add-blackout-link">
          <button
            type="button"
            onClick={onAddBlackoutDate}
            className="add-another-blackout-btn"
          >
            Add another blackout
          </button>
        </div>
      )}
    </div>
  );
}

BlackoutDatesSection.propTypes = {
  blackoutDates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      dates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      allowStayThrough: PropTypes.bool,
    })
  ),
  onBlackoutDateChange: PropTypes.func.isRequired,
  onRemoveBlackoutDate: PropTypes.func.isRequired,
  onAddBlackoutDate: PropTypes.func.isRequired,
  onToggleAllowStayThrough: PropTypes.func.isRequired,
  onRemoveSection: PropTypes.func,
};

export default BlackoutDatesSection;
